import { createSelector } from 'reselect';

export const fetchingEmployees = state => state.employees.get('isFetching');
const allEmployees = state => state.employees.get('employees');
export const getAllEmployees = createSelector([allEmployees], employees => employees.toArray());
